import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/projects/watermark', 'put'>;
type ResponseBody = OASOutput<O, '/api/projects/watermark', 'put'>;

type Params = {
  projectId: number;
  watermark: string;
};

type Result = {
  id: number;
};

export const updateProjectWatermarkFactory = (apiClient: ApiClient) => {
  const updateProjectWatermark = async (variables: Params) => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/projects/watermark'].put(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        projectId: input.projectId,
        watermark: input.watermark,
      },
    };
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
    };
  };

  return updateProjectWatermark;
};
